<template>
  <router-link
    class="block bg-nucleus-white hover:bg-nucleus-listBgHover hover:border-nucleus-listBgHover p-3 text-nucleus-text rounded transition flex border border-nucleus-white mb-1 link"
    :to="to"
  >
    <div
      class="icon text-3xl leading-none p-2 mr-6 flex self-center transition rounded-full"
      :class="['icon-' + icon, getIconColour()]"
    ></div>
    <div>
      <div class="font-bold">
        {{ name }}&nbsp;
        <span
          v-if="allowance"
          class="text-sm text-nucleus-grey font-normal align-right"
        >
          {{ allowance.used }}
          <span class="text-nucleus-lightGrey font-bold">|</span>
          {{ allowance.remaining }}
          <span class="text-nucleus-lightGrey font-bold">|</span>
          {{ $t("pages.usage.expires", { expiry: allowance.licenseExpiry }) }}
        </span>
      </div>
      <div class="text-nucleus-grey">{{ getRoleName(room) }}</div>
      <div class="text-sm mt-1" :class="getStatusColor()">
        {{ getStatusName(status) }}
      </div>
    </div>
  </router-link>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    name: String,
    icon: String,
    room: String,
    status: String,
    to: String,
    allowance: Object,
  },
  methods: {
    getIconColour() {
      const text = this.status.toLowerCase();
      switch (text) {
        case "started":
          return "text-white bg-nucleus-primaryBlue";
        default:
          return "text-nucleus-text bg-nucleus-iconBg";
      }
    },
    getStatusColor() {
      const text = this.status.toLowerCase();
      switch (text) {
        case "active":
        case "started":
        case "enabled":
        case "joined":
        case "verified":
        case "confirmed":
          return "text-nucleus-primaryBlue font-bold";
        case "pending":
          return "text-nucleus-primaryBlue";
        case "failed":
        case "declined":
        case "reset_required":
        case "force_password_change":
          return "text-nucleus-error font-bold";
        default:
          return "text-nucleus-text";
      }
    },
    getStatusName(name: string) {
      switch (name) {
        case "UNVERIFIED":
          return this.$t("status.unverified");
        case "VERIFICATION_REQUESTED":
          return this.$t("status.invited");
        case "VERIFIED":
          return this.$t("status.verified");
        case "UNCONFIRMED":
          return this.$t("status.unconfirmed");
        case "CONFIRMED":
          return this.$t("status.registered");
        case "ARCHIVED":
          return this.$t("status.archived");
        case "UNKNOWN":
          return this.$t("status.unknown");
        case "RESET_REQUIRED":
          return this.$t("status.passwordResetRequired");
        case "FORCE_CHANGE_PASSWORD":
          return this.$t("status.passwordChangeRequested");
        case "NOT_SENT":
          return this.$t("status.inviteNotSent");
        case "SENT":
          return this.$t("status.inviteSent");
        case "DECLINED":
          return this.$t("status.declined");
        case "JOINED":
          return this.$t("status.joined");
        case "PENDING":
          return this.$t("status.prepared");
        case "STARTING":
          return this.$t("status.starting");
        case "STARTED":
          return this.$t("status.active");
        case "FINISHED":
          return this.$t("status.finished");
        case "FAILED":
          return this.$t("status.failedToStart");
        case "DISABLED":
          return this.$t("status.deactivated");
        case "ACTIVE":
          return this.$t("status.active");
        default:
          return name;
      }
    },
    getRoleName(name: string) {
      switch (name) {
        case "LOCAL_ADMIN":
          return this.$t("role.localAdmin");
        case "STAFF":
          return this.$t("role.staff");
        case "SERVICE_ADMIN":
          return this.$t("role.serviceAdmin");
        default:
          return name;
      }
    },
  },
})
export default class ListItem extends Vue {}
</script>

<style lang="scss" scoped>
.link {
  &.router-link-active {
    @apply bg-nucleus-listBgActive border-nucleus-listBorderActive;
    .icon {
      @apply bg-nucleus-primaryBlue text-nucleus-white;
    }
  }
}
</style>
